<p class="text-body-medium">
    {{ _apiError?.message ?? _error?.message ?? _error }}
</p>

<ng-container *ngIf="_apiError?.validationErrorMessages as validationMessages">
    <ul *ngIf="validationMessages.length > 1">
        <li *ngFor="let message of validationMessages">{{ message }}</li>
    </ul>
</ng-container>
